import { Link } from 'react-router-dom';
import { productCategories } from '@/mocks/productsData';

interface CategoryTabsProps {
  activeId: string;
}

export default function CategoryTabs({ activeId }: CategoryTabsProps) {
  return (
    <div className="sticky top-[68px] md:top-[76px] z-40 w-full bg-background-50 border-b border-background-200">
      <div className="w-full px-4 md:px-8">
        <div className="flex items-center gap-2 overflow-x-auto py-3 [scrollbar-width:none] [&::-webkit-scrollbar]:hidden">
          {productCategories.map((category) => {
            const isActive = category.id === activeId;
            return (
              <Link
                key={category.id}
                to={`/products/${category.id}`}
                className={`flex items-center gap-2 px-4 py-2 rounded-full text-sm font-semibold transition-colors cursor-pointer whitespace-nowrap ${
                  isActive
                    ? 'bg-primary-500 text-background-50'
                    : 'bg-background-100 text-foreground-700 hover:bg-secondary-100 hover:text-secondary-900'
                }`}
              >
                <i className={`${category.icon} text-base`}></i>
                {category.name}
              </Link>
            );
          })}
        </div>
      </div>
    </div>
  );
}